export const isVideoReady = (video: HTMLVideoElement): boolean => {
  return video.readyState >= video.HAVE_METADATA;
};

export const isVideoPlaying = (video: HTMLVideoElement): boolean => {
  return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > video.HAVE_CURRENT_DATA;
};

export const playVideo = (video: HTMLVideoElement): void => {
  if (!isVideoReady(video)) return;

  video.play();
};

export const pauseVideo = (video: HTMLVideoElement): void => {
  if (!isVideoPlaying(video)) return;

  video.pause();
};
